module.exports = __webpack_public_path__ + "static/media/ic_theme_infrastructure.89cf33c6.svg";